export default __webpack_public_path__ + "static/new-main-char-d1d5a9261bacfae4a3a68587759e8347.png";